import { ProductMainGroups } from '@onrunning/backstage-models';

export class OpenAndUpcomingProductModel {
  productExternalNumber: string;
  productModelName: string;
  productName: string;
  productTypeName: ProductMainGroups;
  productPhaseInDate: string;
  productGender: string;
  productImageUrl: string;
  productInitialPhaseInDate: string;
}
